var SENTRY_RELEASE;SENTRY_RELEASE={name: "Grokio", version: "6.1.27"};